import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../../contexts/authContext';
import { morgansClient } from '../../../lib/connect/clients';
const LANDSCAPE_SEATS_KEY = [
    'landscape-seats'
];
export function useLandscapeSeats(landscapeId) {
    const { user } = useAuth();
    const enabled = !!user?.tenant_id && !!user?.id && !!landscapeId;
    const query = useQuery({
        queryKey: [
            ...LANDSCAPE_SEATS_KEY,
            user?.tenant_id ?? '',
            landscapeId,
            user?.id ?? ''
        ],
        queryFn: ()=>morgansClient.getLandscapeSeats({
                landscapeId
            }),
        enabled
    });
    return {
        ...query,
        data: enabled && !query.isError ? query.data : undefined
    };
}
/** Keep the Growth gate and content-free presence hint alongside the seats. */ export function useListSeats(filter, active = true) {
    const { user } = useAuth();
    const enabled = active && !!user?.tenant_id && !!user?.id;
    const query = useQuery({
        queryKey: [
            ...LANDSCAPE_SEATS_KEY,
            user?.tenant_id ?? '',
            'list',
            user?.id ?? '',
            filter
        ],
        queryFn: ()=>morgansClient.listSeats(filter),
        enabled
    });
    return {
        ...query,
        data: enabled && !query.isError ? query.data : undefined
    };
}
export function useSuggestSeatRounds(filter) {
    const { user } = useAuth();
    const enabled = !!user?.tenant_id && !!user?.id && !!filter.seatId && !!filter.landscapeId;
    const query = useQuery({
        queryKey: [
            ...LANDSCAPE_SEATS_KEY,
            user?.tenant_id ?? '',
            'suggestions',
            user?.id ?? '',
            filter
        ],
        queryFn: ()=>morgansClient.suggestSeatRounds(filter),
        enabled
    });
    return {
        ...query,
        data: enabled && !query.isError ? query.data : undefined
    };
}
export function useUpsertSeat() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>(await morgansClient.upsertSeat(input)).seat,
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
export function useUpsertSeatRound() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>(await morgansClient.upsertSeatRound(input)).round,
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
export function useArchiveSeatRound() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input)=>morgansClient.archiveSeatRound(input),
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
export function useSetLandscapeSeat() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input)=>morgansClient.setLandscapeSeat(input),
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
export function useSplitSeat() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>(await morgansClient.splitSeat(input)).seat,
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
export function useMergeSeats() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>(await morgansClient.mergeSeats(input)).survivor,
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
export function useUnmergeSeat() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>(await morgansClient.unmergeSeat(input)).seat,
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: LANDSCAPE_SEATS_KEY
            })
    });
}
